"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kpi = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var execution_1 = require("../execution");
var FormattedNumber_1 = require("./FormattedNumber");
var KpiError_1 = require("./KpiError");
var react_intl_1 = require("react-intl");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var base_1 = require("../base");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
//
// Internals
//
var KpiLoading = function () { return react_1.default.createElement(base_1.LoadingComponent, { inline: true }); };
var CoreKpi = function (props) {
    var backend = props.backend, workspace = props.workspace, measure = props.measure, filters = props.filters, separators = props.separators, _a = props.LoadingComponent, LoadingComponent = _a === void 0 ? KpiLoading : _a, _b = props.ErrorComponent, ErrorComponent = _b === void 0 ? KpiError_1.KpiError : _b, onError = props.onError, onLoadingChanged = props.onLoadingChanged, onLoadingFinish = props.onLoadingFinish, onLoadingStart = props.onLoadingStart, intl = props.intl;
    ts_invariant_1.default(backend && workspace, "backend and workspace must be either specified explicitly or be provided by context");
    var execution = backend
        .withTelemetry("KPI", props)
        .workspace(workspace)
        .execution()
        .forItems([measure], filters);
    return (react_1.default.createElement(execution_1.RawExecute, { execution: execution, onLoadingStart: onLoadingStart, onLoadingChanged: onLoadingChanged, onLoadingFinish: onLoadingFinish, onError: onError }, function (_a) {
        var error = _a.error, isLoading = _a.isLoading, result = _a.result;
        if (error) {
            return (react_1.default.createElement(ErrorComponent, { code: error.message, message: intl.formatMessage({ id: "visualization.ErrorMessageKpi" }) }));
        }
        if (isLoading || !result) {
            return react_1.default.createElement(LoadingComponent, null);
        }
        var measureData = getMeasureData(result);
        var measureFormat = measure.measure.format || getMeasureFormat(result);
        return (react_1.default.createElement(FormattedNumber_1.FormattedNumber, { className: "gdc-kpi", value: measureData, format: measureFormat, separators: separators }));
    }));
};
var getMeasureData = function (result) {
    var _a;
    var data = result.rawData().data();
    var measure = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a[0];
    if (isNil_1.default(measure)) {
        return "";
    }
    return parseFloat(measure);
};
var getMeasureFormat = function (result) {
    var _a, _b;
    var headerItems = result.meta().measureDescriptors();
    return (_b = (_a = headerItems === null || headerItems === void 0 ? void 0 : headerItems[0]) === null || _a === void 0 ? void 0 : _a.measureHeaderItem) === null || _b === void 0 ? void 0 : _b.format;
};
var IntlKpi = react_intl_1.injectIntl(CoreKpi);
var RenderKpi = function (props) {
    var locale = props.locale;
    return (react_1.default.createElement(base_1.IntlWrapper, { locale: locale },
        react_1.default.createElement(IntlKpi, tslib_1.__assign({}, props))));
};
/**
 * Kpi is a simple component which calculates and renders a single formatted measure value. The the value
 * is rendered inside a <span> element.
 *
 * Kpi component is useful for instance for embedding data values into text paragraphs.
 *
 * See also the {@link @gooddata/sdk-ui-charts#Headline} component for a more 'chart-like' variant.
 *
 * @public
 */
exports.Kpi = base_1.withContexts(RenderKpi);
//# sourceMappingURL=Kpi.js.map